import ApiPermissions from '@/enums/ApiPermissions';
import Http from '@/services/Http';

const path = 'roles';
const client = new Http(path);

function can(user, permissions) {
  const userPermissions = Array.isArray(user?.permissions)
    ? user.permissions
    : ApiPermissions.memberValues;
  return (
    userPermissions.includes(ApiPermissions.ALL) ||
    userPermissions.includes(permissions)
  );
}

function hasAllPermissions(user) {
  return ApiPermissions.values
    .filter((permission) => permission !== ApiPermissions.ALL)
    .every((permission) => can(user, permission));
}

function isAdmin(user) {
  return (
    Array.isArray(user?.permissions) &&
    user.permissions.includes(ApiPermissions.ALL)
  );
}

function isSameUser(user, other) {
  if (user?.id != null && other?.id != null) {
    return String(user.id) === String(other.id);
  }
  return (
    user?.email != null && other?.email != null && user.email === other.email
  );
}

function isSenderSameLoggedUserOrWithoutReviser(user, sender) {
  if (sender === null) {
    return true;
  }
  return isSameUser(user, sender);
}

function listAvailableRolesProfile(pathParams) {
  return client.get('', '', pathParams === undefined ? '' : `?${pathParams}`);
}

const rolesTranslationsKeys = {
  admin: 'usersGuestCardTable.profiles.admin',
  member: 'usersGuestCardTable.profiles.member',
  'envelope-manager': 'usersGuestCardTable.profiles.envelope-manager',
  'envelope-creator': 'usersGuestCardTable.profiles.envelope-creator',
  'envelope-reviewer': 'usersGuestCardTable.profiles.envelope-reviewer',
  'user-manager': 'usersGuestCardTable.profiles.user-manager',
  'workspace-manager': 'usersGuestCardTable.profiles.workspace-manager',
  finance: 'usersGuestCardTable.profiles.finance',
  management: 'usersGuestCardTable.profiles.management',
  'storage-manager': 'usersGuestCardTable.profiles.storage-manager',
};

export default {
  can,
  hasAllPermissions,
  isAdmin,
  isSameUser,
  isSenderSameLoggedUserOrWithoutReviser,
  listAvailableRolesProfile,
  rolesTranslationsKeys,
};
